/** The first word of a warehouse PersonName, for "Hi, <first name>"; "there" when blank. */
export function firstName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "there";
  return trimmed.split(/\s+/)[0] ?? trimmed;
}
